import React from 'react';

import Form from '@/components/Form';

import { ECustomerSkin } from '@/helpers/API/requests/interfaces/customer';

import Layout from './Layout';

import { TPersonalizationStepForm } from './interfaces';
import LocaleText from '@/components/Intl/LocaleText';

const Skin: React.FC<TPersonalizationStepForm> = ({ formRef }) => (
    <Layout title='form.personalizationStep.skin.title'>
    {Object.values(ECustomerSkin).map(value => (
        <Form.RadioButton
            key={value}
            name='skin'
            value={value}
            sentenceCase
            onChanged={() => {
                formRef.current!.next();
            }}
        >
            <LocaleText>{'form.personalizationStep.radio.' + value}</LocaleText>
        </Form.RadioButton>
    ))}
    </Layout>
);

export default Skin;